// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__YU2JP","colMaxWidth":"Table_colMaxWidth__28NPG"};